<div class="out" #divContainer>
  <!-- MAKE SURE NOT TO PUT ANY THING INSIDE -->
</div>